import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Search } from 'lucide-react';

interface Section {
  id: string;
  title: string;
  difficulty: 'Easy' | 'Medium' | 'Hard';
}

interface Topic {
  id: string;
  title: string;
  slug: string;
  sections: Section[];
}

const topics: Topic[] = [
  {
    id: '1',
    title: 'Arrays',
    slug: 'arrays',
    sections: [
      { id: '1-1', title: 'Two Sum', difficulty: 'Easy' },
      { id: '1-2', title: 'Maximum Subarray', difficulty: 'Medium' },
      { id: '1-3', title: 'Merge Intervals', difficulty: 'Hard' },
    ],
  },
  {
    id: '2',
    title: 'Linked Lists',
    slug: 'linked-lists',
    sections: [
      { id: '2-1', title: 'Reverse Linked List', difficulty: 'Easy' },
      { id: '2-2', title: 'Detect Cycle', difficulty: 'Medium' },
      { id: '2-3', title: 'Merge K Sorted Lists', difficulty: 'Hard' },
    ],
  },
  {
    id: '3',
    title: 'Trees',
    slug: 'trees',
    sections: [
      { id: '3-1', title: 'Maximum Depth', difficulty: 'Easy' },
      { id: '3-2', title: 'Validate BST', difficulty: 'Medium' },
      { id: '3-3', title: 'Serialize Binary Tree', difficulty: 'Hard' },
    ],
  },
  {
    id: '4',
    title: 'Dynamic Programming',
    slug: 'dynamic-programming',
    sections: [
      { id: '4-1', title: 'Climbing Stairs', difficulty: 'Easy' },
      { id: '4-2', title: 'Coin Change', difficulty: 'Medium' },
      { id: '4-3', title: 'Edit Distance', difficulty: 'Hard' },
    ],
  },
];

export function Sidebar() {
  console.log("GERE");
  const { slug } = useParams();
  const [searchQuery, setSearchQuery] = useState('');
  
  const filteredTopics = topics.map(topic => ({
    ...topic,
    sections: topic.sections.filter(section =>
      section.title.toLowerCase().includes(searchQuery.toLowerCase())
    ),
  })).filter(topic => 
    topic.title.toLowerCase().includes(searchQuery.toLowerCase()) || topic.sections.length > 0
  );

  return (
    <div className="w-80 h-screen bg-gray-100 p-4 border-r overflow-y-auto">
      <div className="mb-6">
        <div className="relative">
          <input
            type="text"
            placeholder="Search problems..."
            className="w-full px-4 py-2 pl-10 rounded-lg border focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <Search className="absolute left-3 top-2.5 text-gray-400 w-5 h-5" />
        </div>
      </div>

      <nav>
        <ul className="space-y-4">
          {filteredTopics.map((topic) => (
            <li key={topic.id} className="rounded-lg bg-white shadow-sm">
              <Link
                to={`/codespace/${topic.slug}`}
                className={`block p-3 hover:bg-gray-50 rounded-t-lg transition-colors ${
                  topic.slug === slug ? 'bg-gray-50' : ''
                }`}
              >
                <span className="font-semibold text-gray-900">{topic.title}</span>
              </Link>
              <ul className="px-3 pb-3 space-y-1">
                {topic.sections.map((section) => (
                  <li key={section.id}>
                    <Link
                      to={`/codespace/${topic.slug}/${section.id}`}
                      className="block p-2 text-sm hover:bg-gray-50 rounded-md transition-colors"
                    >
                      <div className="flex justify-between items-center">
                        <span className="text-gray-700">{section.title}</span>
                        <span className={`text-xs px-2 py-1 rounded ${
                          section.difficulty === 'Easy' ? 'bg-green-100 text-green-800' :
                          section.difficulty === 'Medium' ? 'bg-yellow-100 text-yellow-800' :
                          'bg-red-100 text-red-800'
                        }`}>
                          {section.difficulty}
                        </span>
                      </div>
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}